import { required, integer, minValue, maxValue, maxLength, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a group name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Group name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('Name can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/&+.,'"()% -]+$/)),
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Group name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('English name can include English letters, numbers, and certain special characters.'), helpers.regex(/^[A-Za-z0-9_/&+.,'"()% -]+$/)),
      },
      is_required: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      allow_multiple: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      min_options: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), requiredIf(formState.is_required && formState.allow_multiple)),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Min. selection must be at least') +  ' ' + $params.min,
          minValue(1)
        ),
      },
      max_options: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), requiredIf(formState.is_required && formState.allow_multiple)),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Min. selection must be at least') +  ' ' + $params.min,
          minValue(formState.min_options)
        ),
        maxValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Max. selection cannot exceed') +  ' ' + $params.max,
          maxValue(formState.options.length)
        ),
      },
      recipe_behavior: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      options: {
        required: helpers.withMessage(i18n.global.t('Please add at least one option.'), required)
      }
    }
  }
};
